// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"05556fd4","78":"9d767622","81":"e6d15077","118":"5f89ee34","275":"98ee39cd","341":"4d3c0657","756":"71dda27b","774":"370bf918"}[chunkId] + ".chunk.css";
};